import { useFlags as useLDFlags } from 'launchdarkly-react-client-sdk'

export const useFlags = window.ldFeatureFlags
  ? () => window.ldFeatureFlags
  : useLDFlags
